import { BaseApi } from "../BaseApi";
import { InterceptToken } from "../../interceptors/TokenInterceptor";
import ResponseCode from "../ResponseCode";

const getZonasUrl = "api/v1/websalud/primeraars/catalogo/zonas";

const getProvinciasUrl = "api/v1/websalud/primeraars/catalogo/provincias";

const getDiagnosticosUrl = "api/v1/websalud/primeraars/catalogo/diagnosticos";

const mockGrupos = [
  { id: 1, nombre: "Administradores" },
  { id: 2, nombre: "Usuarios" },
  { id: 3, nombre: "Supervisores" },
  { id: 4, nombre: "Auditores" },
];

const mockDepartamentos = [
  { id: 1, nombre: "Sistemas" },
  { id: 2, nombre: "Servicios" },
  { id: 3, nombre: "Comercial" },
  { id: 4, nombre: "Administración" },
  { id: 5, nombre: "Recursos Humanos" },
];

const getZonas = (request) =>
  InterceptToken(BaseApi.get, getZonasUrl, request).then(
    (response) => response.data
  );

const getProvincias = (request) =>
  InterceptToken(BaseApi.get, getProvinciasUrl, request).then(
    (response) => response.data
  );

const getDiagnosticos = () =>
  InterceptToken(BaseApi.get, getDiagnosticosUrl, null).then(
    (response) => response.data
  );

const getGrupos = () =>
  new Promise((resolve) => {
    // Using timeout to simulate API call
    setTimeout(() => {
      resolve({
        respuesta: {
          codigo: ResponseCode.OK.code,
          mensaje: ResponseCode.OK.message,
        },
        data: {
          grupos: mockGrupos,
        },
      });
    }, 500);
  });

const getDepartamentos = () =>
  new Promise((resolve) => {
    // Using timeout to simulate API call
    setTimeout(() => {
      resolve({
        respuesta: {
          codigo: ResponseCode.OK.code,
          mensaje: ResponseCode.OK.message,
        },
        data: {
          departamentos: mockDepartamentos,
        },
      });
    }, 500);
  });

const exportedObject = {
  getZonas,
  getProvincias,
  getDiagnosticos,
  getGrupos,
  getDepartamentos,
};

export default exportedObject;
